import styled, { css } from 'styled-components';

const EditorRow = styled.div`
  color: #939393;
  margin-top: 2px;
  margin-bottom: 30px;

  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${props =>
    props.width &&
    css`
      width: ${props.width}px;

      @media (max-width: 700px) {
        width: calc((${props.width / 2} / 350) * 100vw);
      }
    `}

  > label {
    letter-spacing: -0.2px;
    pointer-events: none;
  }
`;

export default EditorRow;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorRow/index.jsx